import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://zzintfeodyxtufwucmkl.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp6aW50ZmVvZHl4dHVmd3VjbWtsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ5MTY1ODgsImV4cCI6MjA5MDQ5MjU4OH0.wlAgJ2VLKbrDhGI5oholWHf9wWPoyMOeXGBB9rbID0M'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})